import L from "leaflet";
import React, { useCallback, useEffect, useState } from "react";
import { Marker, useMap } from "react-leaflet";
import { Link } from "react-router-dom";
import useSupercluster from "use-supercluster";
import { IMAGE_BASE_URL } from "../data/baseURL";
import locationBlueIcon from "../images/location-blue.png";
import locationGreenIcon from "../images/location-green.png";
import locationIcon from "../images/location.png";

const icons = {};
const fetchIcon = (count, size) => {
  if (!icons[count]) {
    icons[count] = L.divIcon({
      html: `<div class="cluster-marker" style="width: ${size}px; height: ${size}px;">
        ${count}
      </div>`,
    });
  }
  return icons[count];
};

const cuffs = new L.Icon({
  iconUrl: locationGreenIcon,
  iconSize: [26, 48],
  iconAnchor: [17, 45],
  className: "map-company-icon-height",
});

const cuffs2 = new L.Icon({
  iconUrl: locationBlueIcon,
  iconSize: [26, 48],
  iconAnchor: [26, 48],
  className: "map-company-icon-height",
});

const cuffs3 = new L.Icon({
  iconUrl: locationIcon,
  iconSize: [26, 48],
  iconAnchor: [16, 27],
  className: "map-company-icon-height",
});

function ShowCompanyLocations({ companies, handleSelectedIndex }) {
  const maxZoom = 22;
  const [bounds, setBounds] = useState(null);
  const [zoom, setZoom] = useState(13);
  const map = useMap();

  const updateMap = useCallback(() => {
    const b = map.getBounds();
    setBounds([
      b.getSouthWest().lng,
      b.getSouthWest().lat,
      b.getNorthEast().lng,
      b.getNorthEast().lat,
    ]);
    setZoom(map.getZoom());
  }, []);

  const onMove = useCallback(() => {
    updateMap();
  }, [updateMap]);

  React.useEffect(() => {
    updateMap();
  }, [updateMap]);

  useEffect(() => {
    map.on("move", onMove);
    return () => {
      map.off("move", onMove);
    };
  }, [map, onMove]);

  const points = companies.map((company) => ({
    type: "Feature",
    properties: {
      cluster: false,
      id: company?.id,
      companyName: company?.name,
      logo: company?.icon,
      address: company?.address,
      companyType: company?.company_type,
    },
    geometry: {
      type: "Point",
      coordinates: [
        parseFloat(company?.latitude),
        parseFloat(company?.longitude),
      ],
    },
  }));

  const { clusters, supercluster } = useSupercluster({
    points: points,
    bounds: bounds,
    zoom: zoom,
    options: { radius: 75, maxZoom: 17 },
  });

  return (
    <>
      {clusters?.map((cluster) => {
        const [longitude, latitude] = cluster.geometry.coordinates;

        const { cluster: isCluster, point_count: pointCount } =
          cluster.properties;

        if (isCluster) {
          return (
            <Marker
              key={`cluster-${cluster.id}`}
              position={[latitude, longitude]}
              icon={fetchIcon(
                pointCount,
                10 + (pointCount / points.length) * 40
              )}
              eventHandlers={{
                click: () => {
                  const expansionZoom = Math.min(
                    supercluster.getClusterExpansionZoom(cluster.id),
                    maxZoom
                  );
                  map.setView([latitude, longitude], expansionZoom, {
                    animate: true,
                  });
                },
              }}
            />
          );
        }

        return (
          <Marker
            key={`crime-${cluster.properties.id}`}
            position={[latitude, longitude]}
            icon={
              cluster.properties.companyType === "Resident Office"
                ? cuffs3
                : cluster.properties.companyType === "Regional Office"
                ? cuffs
                : cuffs2
            }
            eventHandlers={{
              click: () => {
                handleSelectedIndex(cluster.properties.id);
              },
            }}
          >
            {/* <Popup>
              <MapProfileCard
                companyName={companyName}
                companyAddress={address}
                companyLogo={logo}
                id={id}
              />
            </Popup> */}
          </Marker>
        );
      })}
    </>
  );
}

export default ShowCompanyLocations;

function MapProfileCard({ companyName, companyAddress, companyLogo, id }) {
  return (
    <div className="text-center">
      <div className="rounded-full mx-auto">
        <img
          src={`${IMAGE_BASE_URL}/${companyLogo}`}
          alt="James Kong"
          className="w-full h-full"
          style={{ height: "40px", width: "200px", objectFit: "cover" }}
        />
      </div>
      <span className="text-gray-dark fs-16 my-3 d-block">
        {companyAddress}
      </span>
      <Link
        to={`/projects?company=${companyName}&id=${id}`}
        className="d-block w-full bg-american-yellow py-3 text-decoration-none rounded fs-14 text-white mt-2 px-4"
      >
        View Projects
      </Link>
    </div>
  );
}
